import wretch from "wretch";

const apiClient = wretch().options({ credentials: "same-origin" });

export function getRequest(url, params) {
  var client = apiClient.url(url);
  if (params) client = client.query(params);
  return client.get();
}

export function storyPageLoadItems(pageNumber, mostPopular) {
  const FIELDS =
    "id,headline,metadata,slug,url,hero-image-s3-key,tags,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,sections,story-template,cards";

  return global
    .wretch("/api/v1/stories")
    .query({
      fields: FIELDS,
      limit: 5,
      offset: 5 * pageNumber
    })
    .get()
    .json(response => response.stories.map(story => ({ story, mostPopular: mostPopular })));
}

export const loadNextStories = pageNumber => {
  const FIELDS = "id,slug,first-published-at,last-published-at";
  return global
    .wretch("/api/v1/collections/latest-news")
    .query({
      fields: FIELDS,
      limit: 20
    })
    .get()
    .json(response =>
      response.items.filter(i => i.type === "story").map(({ story }) => ({ slug: story.slug, id: story.id }))
    );
};

// Returns the current User
export function getUser() {
  return global
    .wretch()
    .url("/api/auth/v1/users/me")
    .get()
    .json(res => Promise.resolve(res))
    .catch(ex => Promise.reject(ex));
}

// Logout the User
export function logout() {
  return global
    .wretch()
    .url("/api/auth/v1/logout")
    .get()
    .res(() => Promise.resolve())
    .catch(ex => Promise.reject(ex));
}

// Update User Information
export function updateUserInformation(data) {
  return global
    .wretch()
    .url("/api/auth/v1/users/profile")
    .post(data)
    .res(() => Promise.resolve())
    .catch(ex => Promise.reject(ex));
}

// Update User Metadata
export function updateUserMetadata(data) {
  return global
    .wretch()
    .options({ credentials: "same-origin" })
    .url("/api/member/metadata")
    .post({ metadata: data })
    .res(() => Promise.resolve())
    .catch(ex => Promise.reject(ex));
}

// Generate JWT token from server which is used in access-type
export function generateJwtToken(email, id, name) {
  return global
    .wretch()
    .url("/generate-token")
    .post({ email, id, name })
    .json(result => result.token)
    .catch(ex => Promise.reject(ex));
}

export function sendSupportEmail(data) {
  return global
    .wretch()
    .url("/support-mail")
    .post(data)
    .res(res => res)
    .catch(ex => Promise.reject(ex));
}

export function sendSubscribeUserNPEmail(data) {
  return global
    .wretch()
    .url("/subscribe-user")
    .post(data)
    .res(res => res)
    .catch(ex => Promise.reject(ex));
}

export function sendSubscribeUserToAdminEmail(data) {
  return global
    .wretch()
    .url("/subscription")
    .post(data)
    .res(res => res)
    .catch(ex => Promise.reject(ex));
}

export function getPageCommentsData(accountId, url) {
  const encodedUrl = btoa(url);
  return global
    .wretch()
    .url(`https://www.metype.com/api/v1/accounts/${accountId}/pages/${encodedUrl}`)
    .get()
    .json(res => res)
    .catch(ex => Promise.reject(ex));
}
